import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { Banner } from '../../types/banner';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  banner: Banner;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.http.get<Banner>(environment.api.getBanner).subscribe(data => {
      this.banner = data;
    });
  }

  getEndDate() {
    try {
      const endDate = moment(this.banner.endDate);
      return endDate.format('LL') + ' at ' + endDate.format('LT') + '.';
    } catch (x) {
      return this.banner.endDate;
    }
  }
}
